// frontend/src/pages/Forbidden.js

import React from 'react';
import { Link } from 'react-router-dom';

const Forbidden = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
            <h1 className="text-4xl font-bold text-red-600 mb-4">403 - Acesso Negado</h1>
            <p className="text-lg mb-6">Você não tem permissão para acessar esta página.</p>
            <Link to="/dashboard" className="text-blue-500 hover:underline">
                Voltar
            </Link>
        </div>
    );
};

export default Forbidden;
